// extracted by mini-css-extract-plugin
module.exports = {"jobRankingLink":"jobRankingLink"};